module.exports = __webpack_public_path__ + "static/media/chemicals.d2b608bc.png";